module.exports = {
    ClassificationRegulations: 'Regolamenti di classificazione',
    NotAvailableInChosenLanguage: 'I regolamenti di classificazione sono disponibili solo in inglese e olandese'
};